import { CreateElement } from 'src/vue'
import { Component, Prop } from 'vue-property-decorator'
import Vue from 'vue'

import AddKgi from '@src/routes/members/components/health-goals/add-kgi'
import { HealthIndicatorOptions } from '@src/util/constants'
import { Subtitle1 } from '@src/elements/typography/typography'

import './kgi-tooltip.sass'

@Component
export class KGITooltip extends Vue {

  @Prop({ required: true })
  private closeCallback: () => void

  private selectedKgiType: string | null = null

  private preventAccidentalClose: boolean = false

  constructor () {
    super()
  }

  showAddKgi (kgi: string) {
    this.selectedKgiType = kgi
  }

  showAllOptions () {
    this.selectedKgiType = null
  }

  close () {
    this.selectedKgiType = null
    if (this.closeCallback) {
      this.closeCallback()
    }
  }

  mouseDown (e) {
    let path = e.composedPath && e.composedPath()
    if (!path) return

    let clickedInside = path.filter((el) => {
      // if mousedown event occurs inside the modal, it means the user is selecting some text and the modal should
      // not close if the user releases the mouse outside the modal
      return el && el.classList && el.classList.contains('kgi-tooltip')
    }).length
    this.preventAccidentalClose = clickedInside
  }

  mouseUp () {
    if (!this.preventAccidentalClose) {
      this.close()
    }
    this.preventAccidentalClose = false
  }

  mounted () {
    window.addEventListener('mousedown', this.mouseDown)
    window.addEventListener('mouseup', this.mouseUp)
  }

  beforeDestroy () {
    window.removeEventListener('mousedown', this.mouseDown)
    window.removeEventListener('mouseup', this.mouseUp)
  }

  render (h: CreateElement) {
    let options: any[] = HealthIndicatorOptions.map(option => {
      return <span class='kgi-option' onClick={() => this.showAddKgi(option)}><Subtitle1>{this.$t(`PAGE.MEMBERS.GOALS.KGI.${option}`)}</Subtitle1></span>
    })

    return <div class='tooltip kgi-tooltip'>
      <div class={`${this.selectedKgiType ? 'arrow' : ''} tooltip-title`} ref='title' onClick={this.showAllOptions}>
        <span>{this.$t('PAGE.MEMBERS.GOALS.ADD_KGI_DESCRIPTION')}</span></div>

      {this.selectedKgiType ?
        <AddKgi option={this.selectedKgiType} saveCallback={this.close} />

        : <div>
          {options}
        </div>
      }
    </div>
  }
}
